import { Task } from '@atom/types/task';

import { getTaskField } from './hidotOvertimeReportUtilities';
import ReportSection from './ReportSection';

import classes from './hidotOvertimeReport.module.css';

type LongTextSectionProps = {
  task: Task;
  title: string;
};

const LongTextSection = ({ task, title }: LongTextSectionProps) => {
  const field = getTaskField(task, title);

  return (
    <ReportSection title={title} required={field?.required}>
      <div className={classes.longTextValue}>{field?.value || ''}</div>
    </ReportSection>
  );
};

export default LongTextSection;
